// Library Methods
import { useTranslation } from "react-i18next";

// Components
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";

export default function ProgressionTrendlinesLegend() {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "8px",
      }}
    >
      <Typography fontSize="14px">{t("Legend")}</Typography>
      <Grid container display="flex" rowSpacing="8px" columnSpacing="16px">
        <Grid
          item
          container
          xs={12}
          display="flex"
          rowSpacing="8px"
          columnSpacing="16px"
        >
          <Grid item display="flex" alignItems="center" gap="8px">
            <Box
              sx={{
                backgroundColor: "#000",
                height: "8px",
                width: "8px",
                borderRadius: "50%",
              }}
            />
            <Typography fontSize="12px" color="#000" fontWeight={600}>
              {t("Exam")}
            </Typography>
          </Grid>
          <Grid item display="flex" alignItems="center" gap="8px">
            <Box
              sx={{
                backgroundColor: "#E10C0C",
                height: "8px",
                width: "8px",
                borderRadius: "50%",
              }}
            />
            <Typography fontSize="12px" color="#E10C0C" fontWeight={600}>
              {t("Unreliable Exam")}
            </Typography>
          </Grid>
        </Grid>
      </Grid>
      <Typography sx={{ fontSize: "12px" }}>
        {t("An exam is reliable only if all conditions are met")}:
      </Typography>
      <Grid container display="flex" rowSpacing="8px" columnSpacing="16px">
        <Grid item display="flex" alignItems="center" gap="8px">
          <Typography sx={{ fontSize: "12px" }}>
            {t("False positives")} ≤ 15%
          </Typography>
        </Grid>
        <Grid item display="flex" alignItems="center" gap="8px">
          <Typography sx={{ fontSize: "12px" }}>
            {t("Fixation losses")} ≤ 20%
          </Typography>
        </Grid>
      </Grid>
    </Box>
  );
}
